import {
  selectAuthenticated,
  selectCheckingAuthentication,
  selectFeatureFlagIdentitySet,
} from 'src/store/selectors';
import { store } from 'src/store';

export const indexLoader = async () => {
  const storeState = store.getState();

  if (!selectAuthenticated(storeState) && selectCheckingAuthentication(storeState)) {
    await new Promise((resolve) => {
      const unsubscribe = store.subscribe(() => {
        const newState = store.getState();
        if (
          (selectAuthenticated(newState) && selectFeatureFlagIdentitySet(newState)) ||
          !selectCheckingAuthentication(newState)
        ) {
          unsubscribe();
          resolve(true);
        }
      });
    });
  }

  return null;
};
